var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.75C16.3672 0.75 17.5 1.88281 17.5 3.25V15.75C17.5 17.1562 16.3672 18.25 15 18.25H2.5C1.09375 18.25 0 17.1562 0 15.75V3.25C0 1.88281 1.09375 0.75 2.5 0.75H15ZM13.7109 12.0781C13.7891 11.8047 13.6328 11.4922 13.3594 11.375L11.25 10.4766C10.9766 10.3594 10.7031 10.4375 10.5469 10.6328L9.6875 11.6875C8.32031 11.0234 7.22656 9.92969 6.5625 8.5625L7.61719 7.70312C7.8125 7.54688 7.89062 7.27344 7.77344 7L6.875 4.89062C6.75781 4.61719 6.44531 4.46094 6.17188 4.53906L4.21875 4.96875C3.94531 5.04688 3.75 5.28125 3.75 5.59375C3.75 10.5156 7.73438 14.5 12.6562 14.5C12.9688 14.5 13.2031 14.3438 13.2422 14.0312L13.7109 12.0781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/Telephone.21272ad14e09ed0c792ac28985c28931.svg";
export { ForwardRef as ReactComponent };